import { login,logout,getUserInfo } from "@/api/user";
import { getUserConfig } from "@/api/generalConfig";

const state = {
  token: undefined,
  userInfo: undefined,
  wxUserInfo: undefined,
  userConfig: undefined,
  
}

const mutations = {

  SET_TOKEN(state, token) {
    state.token = token
  },
  DEL_USER_TOKEN(state) {
    state.token = ""
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_WX_USER_INFO(state, wxUserInfo) {
    state.wxUserInfo = wxUserInfo;
  },
  SET_USER_CONFIG(state, userConfig) {
    state.userConfig = userConfig;
  }
}

const actions = {
  setToken({ commit }, token) {
    commit('SET_TOKEN', token)
  },
  delUserAllInfo({ commit }) {
    commit('DEL_USER_TOKEN')
  },
  //獲取用戶配置
  getUserConfig({ commit, state }) {
    getUserConfig({ uid: state.userInfo.id })
      .then((res) => {
        if (res.code === 1 && res.data) {
          commit('SET_USER_CONFIG', res.data);
        }
      })
      .catch(() => {});
  },
  // 登錄
  login({ commit }, data) {
    return new Promise((resolve, reject) => {
      login(data).then(res => {
        commit('SET_TOKEN', res.token);
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 獲取用戶信息
  getUserInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(res => {
        commit('SET_USER_INFO', res.data)
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 退出系統
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then((res) => {
        commit('SET_TOKEN', undefined)
        commit('SET_USER_INFO', undefined)
        location.reload();//達到清空路由目的
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 退出系統
  UVClogout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then((res) => {
        commit('SET_TOKEN', undefined)
        commit('SET_USER_INFO', undefined)
        location.replace("/uvclogin");//達到清空路由目的
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}